var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9999 12.0001C18.447 12.0001 18 12.4481 18 13V21.0001C18 21.551 17.5519 22 17.0001 22H3C2.44794 22 2.00006 21.551 2.00006 21.0001V7C2.00006 6.44904 2.44794 6.00006 3 6.00006H11.0001C11.553 6.00006 12 5.552 12 5.00012C12 4.44806 11.553 4 11.0001 4H3C1.34601 4 0 5.34601 0 7V21.0001C0 22.6541 1.34601 24.0001 3 24.0001H17.0001C18.6541 24.0001 20.0001 22.6541 20.0001 21.0001V13C20.0001 12.447 19.5529 12.0001 18.9999 12.0001Z",
    fill: "#008787"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.37613 11.0878C9.30618 11.1577 9.25912 11.2467 9.23916 11.3427L8.53219 14.8788C8.49924 15.0427 8.55124 15.2117 8.66916 15.3307C8.76419 15.4257 8.89218 15.4766 9.02328 15.4766C9.05514 15.4766 9.08829 15.4737 9.12124 15.4667L12.6563 14.7598C12.7542 14.7396 12.8432 14.6927 12.9123 14.6226L20.8242 6.71063L17.2892 3.17578L9.37613 11.0878Z",
    fill: "#008787"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2681 0.731277C22.2932 -0.243759 20.7072 -0.243759 19.733 0.731277L18.3491 2.11519L21.8842 5.65022L23.2681 4.26613C23.7401 3.79518 24.0001 3.16713 24.0001 2.49916C24.0001 1.83119 23.7401 1.20314 23.2681 0.731277Z",
    fill: "#008787"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.e1882c7dcf233240be6f5837c38d27ff.svg";
export { ForwardRef as ReactComponent };